import { Button, useBoolModalState } from '@app/core';
import { GdprRuleModal } from './GdprRuleModal';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';
import { Criterion, Field } from '@app/api';
import { useCreateGDPRConsentFieldAndCriterion } from 'lib/criteriaUtils';

const useStyles = createUseStyles((theme: Theme) => ({
  informationBox: {
    display: 'flex',
    borderRadius: theme.borderRadius.std,
    padding: theme.marginBase * 2,
    flexDirection: 'column',
    gap: theme.marginBase,
    marginTop: theme.marginBase * 3,
    backgroundColor: theme.colors.blueMuted,
  },
  btnReadContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  title: {
    ...theme.fonts.label,
  },
  description: {
    ...theme.fonts.caption,
  },
}));

interface Props {
  questionExist: boolean;
  addFieldToForm: (field: Field, criterion: Criterion) => void;
}

export const ScreeningGdprSection = ({
  questionExist,
  addFieldToForm,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [isOpened, open, close] = useBoolModalState();
  const createGDPRCriterion = useCreateGDPRConsentFieldAndCriterion();

  const addGdprConsent = () => {
    const { newConsentField, criterion } = createGDPRCriterion();
    addFieldToForm(newConsentField, criterion);
  };

  return (
    <div className={classes.informationBox}>
      <h5 className={classes.title}>{t('editSession.screening.gdpr.title')}</h5>
      <p className={classes.description}>
        {t('editSession.screening.gdpr.description')}
      </p>
      <div className={classes.btnReadContainer}>
        <Button
          text={t('editSession.screening.gdpr.more')}
          variant="muted"
          small
          onClick={open}
        />
        {!questionExist && (
          <Button
            text={t('editSession.screening.gdpr.addQuestion')}
            variant="muted"
            small
            onClick={addGdprConsent}
          />
        )}
      </div>
      <GdprRuleModal isOpen={isOpened} onRequestClose={close} />
    </div>
  );
};
